import { createFileRoute } from '@tanstack/react-router'

import { FreeTournamentTicketRoute } from '@/pages/promotion/route-entries/free-tournament-tickets'
import { defaultPromoSearch, promoSearchSchema } from '@/pages/promotion/search-schemas'

export const Route = createFileRoute(
  '/_layout/promotion/august-2025/_tabs/free-tournament-tickets',
)({
  validateSearch: (search) => promoSearchSchema.catch(defaultPromoSearch).parse(search),
  component: FreeTournamentTicketRoute,
})
